import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 mb-3">
            为什么选择我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
            芭乐视频为您打造的四大核心观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featureItems.map((item, i) => {
            const iconColors = [
              'bg-primary-100 text-primary-600',
              'bg-accent-100 text-accent-600',
              'bg-secondary-100 text-secondary-700',
              'bg-primary-100 text-primary-600',
            ];
            return (
              <div
                key={i}
                className="flex flex-col items-center text-center p-6 rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-200"
              >
                <div className={`w-14 h-14 flex items-center justify-center rounded-2xl ${iconColors[i]} mb-4`}>
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-2 text-sm">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}